export const S3_MEDIA_PREFIX =
  "https://bairuha-bucket.s3.ap-south-1.amazonaws.com/suprabhaatham/";
/** Epaper pages/covers are backed up under suprabhaatham/epaper/ (see file-upload service). */
export const S3_EPAPER_PREFIX = S3_MEDIA_PREFIX + "epaper/";
const MARKER = "/uploads/suprabhaatham-bucket/";

/** Strip scheme://host from a URL, returning the path with no leading slash / query. */
function pathAfterOrigin(url: string): string {
  const m = url.match(/^[a-z]+:\/\/[^/]+\//i);
  const rest = m ? url.slice(m[0].length) : url.replace(/^\/+/, "");
  return rest.split("?")[0];
}

/**
 * Server-hosted media URL -> its S3 backup URL, or null if not swappable.
 *  - News/library uploads carry the marker /uploads/suprabhaatham-bucket/ -> suprabhaatham/{path}.
 *  - Epaper pages/thumbs (file-upload service) always contain "-epaper-" in the filename
 *    and are served at {host}/{date}/{edition}/{file}. Mapped host-agnostically to
 *    suprabhaatham/epaper/{path}, so it works for prod (e-files) and local dev alike.
 */
export function s3FallbackUrl(url?: string | null): string | null {
  if (!url || typeof url !== "string") return null;
  const i = url.indexOf(MARKER);
  if (i !== -1) {
    const path = url.slice(i + MARKER.length).split("?")[0];
    return path ? S3_MEDIA_PREFIX + path : null;
  }
  if (url.includes("-epaper-")) {
    const path = pathAfterOrigin(url);
    return path ? S3_EPAPER_PREFIX + path : null;
  }
  return null;
}

/** Reusable native <img onError> handler: swap to S3 once. */
export function onImgErrorFallback(
  e: React.SyntheticEvent<HTMLImageElement> | { currentTarget: HTMLImageElement }
) {
  const img = (e as any).currentTarget as HTMLImageElement;
  if (!img || img.dataset.s3tried) return;
  const fb = s3FallbackUrl(img.currentSrc || img.src);
  if (fb && fb !== img.src) {
    img.dataset.s3tried = "1";
    img.src = fb;
  }
}
